// extracted by mini-css-extract-plugin
module.exports = {"container":"_a9ae02f","marketNameContainer":"_0fe43c5","eventStatusContainer":"_89c4e62"};